import { startOfDay, startOfMonth } from 'date-fns';

import {
    Population,
    SELECTED_ITEM_ALL_ID,
} from '../../../user/population-select';
import { DataDimension, DataSource, ReportType } from '../../backend';
import { Step } from '../../builder-selection';
import { currentBuilderState } from '../builder.state';

import { updateSectionLabels } from './update-section-labels.function';

export function reset(dataSource: DataSource = DataSource.Cache): void {
    const state = currentBuilderState();

    state.step = Step.DataSource;
    state.atFinalStep = null;
    state.viewParams = {
        dataSource,
        rawStartDate: startOfMonth(new Date()),
        rawEndDate: startOfDay(new Date()),
        reportType: ReportType.Role,
        dataDimension: DataDimension.SuperGroup,
        site: [
            {
                population: Population.Site,
                id: SELECTED_ITEM_ALL_ID,
                label: null,
            },
        ],
        queue: [
            {
                population: Population.Queue,
                id: SELECTED_ITEM_ALL_ID,
                label: null,
            },
        ],
    };
    state.viewParamLabels = {};

    switch (dataSource) {
        case DataSource.Cache:
            state.selectableRoleIds = [];
            state.selectableSiteIds = [SELECTED_ITEM_ALL_ID];
            state.selectableQueueIds = [SELECTED_ITEM_ALL_ID];
            state.selectableSuperGroupIds = [];
            break;
        case DataSource.Raw:
            state.selectableRoleIds = null;
            state.selectableSiteIds = null;
            state.selectableQueueIds = null;
            state.selectableSuperGroupIds = null;
            break;
    }

    state.metrics = null;
    state.metricKeywords = null;
    state.filteredMetrics = null;
    state.cannotSelectMetrics = null;

    updateSectionLabels();
}
